import { Patient, SessionSummary } from '@bioliberty/lifemind';
import posthog from 'posthog-js';
import { EmptyRecentSessionsList } from './EmptyRecentSessionsList';
import { RecentSessionsListItem } from './RecentSessionsListItem';

export interface RecentSessionsListProps {
  sessions: SessionSummary[];
  patients: Patient[];
}

export function RecentSessionsList({ sessions, patients }: RecentSessionsListProps) {
  if (!sessions.length) {
    return <EmptyRecentSessionsList />;
  }

  const patientsById = patients.reduce<Record<number, Patient>>((acc, patient) => {
    acc[patient.id] = patient;
    return acc;
  }, {});

  return (
    <ul className="flex w-full flex-col gap-5 overflow-auto" data-testid="recent-sessions-list">
      {sessions.map((session, idx) => {
        const patient = patientsById[session.patientId];
        if (!patient) {
          posthog.captureException(
            new Error(`RecentSessionsList: Patient ${session.patientId} not found for session ${session.sessionId}`)
          );
          return null;
        }

        return (
          <RecentSessionsListItem
            key={session.sessionId}
            session={session}
            patient={patient}
            showActivities={idx === 0}
          />
        );
      })}
    </ul>
  );
}
